export default {
	outline: ['btn-icon--outline'],
	topLeft: ['btn-icon--top-left'],
	topRight: ['btn-icon--top-right'],
	bottomLeft: ['btn-icon--bottom-left'],
	bottomRight: ['btn-icon--bottom-right'],
	top: ['btn-icon--top'],
	bottom: ['btn-icon--bottom'],
	left: ['btn-icon--left'],
	right: ['btn-icon--right'],
	rotate: ['btn-icon--rotate']
};
